<template>
	<modal :show="showPopup" :callback="closeHandler" class="c-modal__modified-ui">
		<template #content>
			<DsText html-element="h3" text-style="bold" text-type="heading-3xl" class="popup__headline">{{ vm.currentPage.popupHeadline }}</DsText>
			<DsText v-if="vm.currentPage.popupDescriptionText" html-element="div" text-style="regular" text-type="body-md">
				<span v-html="vm.currentPage.popupDescriptionText"></span>
			</DsText>
		</template>
		<template #actions>
			<DsButtonGroup mobileDirection="column" desktop-alignment="start" desktop-direction="row" class="popup__button-group">
				<DsButton :href="vm.baseViewModel.popupLoginButtonLink" variant="primary">{{ vm.currentPage.popupLoginButtonText }}</DsButton>
				<DsButton :href="vm.baseViewModel.popupCreateAccountButtonLink" v-if="vm.baseViewModel.popupCreateAccountButtonLink">{{ vm.currentPage.popupCreateAccountButtonText }}</DsButton>
			</DsButtonGroup>
			<DsText html-element="p" text-type="body-sm" v-if="vm.currentPage.popupProccessAsGuestLinkText" @click="closeHandler()" class="c-modal__hcp-text">
				<DsText v-if="vm.currentPage.popupProccessAsGuestBeforeLinkText"
						html-element="span"
						text-type="body-sm"
				>
					<span v-html="vm.currentPage.popupProccessAsGuestBeforeLinkText"></span>
				</DsText>
				<a class="ds-text-body-sm ds-text--regular popup__guestlink" v-html="vm.currentPage.popupProccessAsGuestLinkText" @click="closeHandler()"></a>
			</DsText>
		</template>
	</modal>

	<section class="c-full-width-component">
		<div class="ds-layout ds-layout--sidebar-lg head">
			<div class="ds-layout__main">
				<DsText html-element="h1" text-style="medium" text-type="heading-3xl">
					{{ vm.currentPage.headline }}
				</DsText>

				<template v-if="!isGuest">
					<EnrollmentFacilitySelector :select-facility-label="selectFacilityLabel" />
				</template>
			</div>
			<aside class="ds-layout__side">
				<DsAlert
					appearance="attention"
					:text='headAlertText'
				/>
			</aside>
		</div>
	</section>

	<section class="c-full-width-component bg-decorative-3-subtle">
		<div class="ds-layout main">
			<div class="ds-layout__main">
				<DsText html-element="h2" text-style="medium" text-type="heading-2xl">
					{{ vm.currentPage.chooseEnrollmentTypeHeadline }}
				</DsText>

				<div class="c-enrollment-cta__types c-form-latest">
					<ul class="c-enrollment-form" :class="{ shake: !isValid }">
						<template v-for="formType in orderedEnrollmentFormTypes" :key="formType">
							<template v-if="formType === 'IC' && vm.baseViewModel.enableIcTypeSelection">
								<li>
									<RadioButtonBlock name="enrollmentType"
													  :labelText="vm.currentPage.icFormLinkText"
													  :type="vm.baseViewModel.icFormLink"
													  :model-value="enrollmentUrl"
													  @update:model-value="updateEnrollmentUrl($event, formTypeListForIc)"
													  :is-valid="isValid"
													  />

									<transition name="expand">
										<div v-show="formTypeListForIc.length > 0 && enrollmentUrl === vm.baseViewModel.icFormLink"
											 :class="{'delay' : enrollmentUrl === vm.baseViewModel.icFormLink }">
											<div class="inner-list">
												<DsText html-element="p" text-style="medium" text-type="heading-lg">
													{{ vm.currentPage.chooseFormTypeHeadline }}
												</DsText>
												<ul>
													<li v-for="(option, index) in formTypeListForIc" :key="`ic_${option.formType}_${index}`">
														<RadioButtonBlock name="icEnrollmentFormType"
																		  :option="option"
																		  :labelText="option.heading"
																		  :type="option.formType"
																		  :readLessLabel="readLessLabel"
																		  :readMoreLabel="readMoreLabel"
																		  :model-value="enrollmentFormType"
																		  @update:model-value="enrollmentFormType = $event"
																		  />
													</li>
												</ul>
											</div>
										</div>
									</transition>
								</li>
							</template>
							<template v-else-if="formType === 'BC' && vm.baseViewModel.enableBcTypeSelection">
								<li>
									<RadioButtonBlock name="enrollmentType"
													:labelText="vm.currentPage.bcFormLinkText"
													:type="vm.baseViewModel.bcFormLink"
													:model-value="enrollmentUrl"
													@update:model-value="updateEnrollmentUrl($event, formTypeListForBc)"
													:is-valid="isValid"
													/>
									<transition name="expand">
										<div v-show="formTypeListForBc.length > 0 && enrollmentUrl === vm.baseViewModel.bcFormLink"
											:class="{'delay' : enrollmentUrl === vm.baseViewModel.bcFormLink }">
											<div class="inner-list">
												<DsText html-element="p" text-style="medium" text-type="heading-lg">
													{{ vm.currentPage.chooseFormTypeHeadline }}
												</DsText>
												<ul>
													<li v-for="(option, index) in formTypeListForBc" :key="`ic_${option.formType}_${index}`">
														<RadioButtonBlock name="bcEnrollmentFormType"
																		  :option="option"
																		  :labelText="option.heading"
																		  :type="option.formType"
																		  :readLessLabel="readLessLabel"
																		  :readMoreLabel="readMoreLabel"
																		  :model-value="enrollmentFormType"
																		  @update:model-value="enrollmentFormType = $event"
																		  />
													</li>
												</ul>
											</div>
										</div>
									</transition>
								</li>
							</template>
							<template v-else-if="formType === 'OC'">
								<li>
									<RadioButtonBlock name="enrollmentType"
													  :labelText="vm.currentPage.ocFormLinkText"
													  :type="vm.baseViewModel.ocFormLink"
													  :model-value="enrollmentUrl"
													  @update:model-value="updateEnrollmentUrl($event, formTypeListForOc)"
													  :is-valid="isValid"
													  />
									<transition name="expand">
										<div v-show="formTypeListForOc.length && enrollmentUrl === vm.baseViewModel.ocFormLink"
											 :class="{'delay' : enrollmentUrl === vm.baseViewModel.ocFormLink }">
											<div class="inner-list">
												<DsText html-element="p" text-style="medium" text-type="heading-lg">
													{{ vm.currentPage.chooseFormTypeHeadline }}
												</DsText>
												<ul>
													<li v-for="(option, index) in formTypeListForOc" :key="`oc_${option.formType}_${index}`">
														<RadioButtonBlock name="ocEnrollmentFormType"
																		  :option="option"
																		  :labelText="option.heading"
																		  :type="option.formType"
																		  :readLessLabel="readLessLabel"
																		  :readMoreLabel="readMoreLabel"
																		  :model-value="enrollmentFormType"
																		  @update:model-value="enrollmentFormType = $event"
																		  />
													</li>
												</ul>
											</div>
										</div>
									</transition>
								</li>
							</template>
						</template>
					</ul>

					<template v-if="!isValid">
						<div class="alert">
							<DsAlert
									 appearance="danger"
									 :text="vm.currentPage.startFormError"
									 />
						</div>
					</template>
				</div>

				<DsButtonGroup desktopAlignment="start" mobileAlignment="start">
					<DsButton variant="primary" :clickHandler="goToEnrollmetnForm">
						{{ vm.currentPage.startFormButtonText }}
					</DsButton>
				</DsButtonGroup>
			</div>
		</div>

	</section>

</template>
<script setup>
import { computed, ref, watch, onMounted } from 'vue';
import { DsAlert, DsText, DsButtonGroup, DsButton } from '@coloplast/design-system';
import '@coloplast/design-system/dist/components/alert/ds-alert.css';
import Modal from 'shared/components/modal/modal.vue';
import RadioButtonBlock from 'shared/components/RadioButtonBlock/radioButtonBlock.vue';
import EnrollmentFacilitySelector from 'Features/HCPEnrollment/Views/SharedComponents/EnrollmentFacilitySelector/enrollmentFacilitySelector.vue';

const props = defineProps({
	vm: Object,
});

const DEFAULT_ENROLLMENT_FORM_TYPES_ORDER = ['IC', 'BC', 'OC'];

const selectFacilityLabel = props.vm.currentPage.selectFacilityLabel;
const readLessLabel = props.vm.currentPage.readLessLabel;
const readMoreLabel = props.vm.currentPage.readMoreLabel;
const isValid = ref(true);
const enrollmentUrl = ref(null);
const enrollmentFormType = ref(null);
const showPopup = ref(false);

// mounted
onMounted(() => {

	if (props.vm.baseViewModel.showPopup) {
		showPopup.value = true;
	}

	if ( localStorage.getItem("SelectedEnrollmentType") ) {
		const prefilledData = JSON.parse(localStorage.getItem("SelectedEnrollmentType"))
		enrollmentUrl.value = prefilledData.url;
		enrollmentFormType.value = prefilledData.type;
	} else {
		// preselect if enableIcTypeSelection false
		if ( !props.vm.baseViewModel.enableIcTypeSelection ) {
			enrollmentUrl.value = props.vm.baseViewModel.ocFormLink
			if ( props.vm.currentPage?.formTypeListForOc?.length ) {
				enrollmentFormType.value = props.vm.currentPage?.formTypeListForOc[0]?.formType
			}
		}
	}
});

const isGuest = computed(() => props.vm.baseViewModel.isGuest);
const fullUrl = computed(() => {
	let url = null;
	if (enrollmentUrl.value) {
		// for the EPIC integration "&", for other "?"
		let ref = enrollmentUrl?.value.indexOf("?") >= 0 ? "&" : "?"

		url = `${enrollmentUrl.value}${ enrollmentFormType.value ? ref+"type="+enrollmentFormType.value : ''}`
	}
	return url
});

const formTypeListForIc = computed(() => {
	let typesList = [];
	if (isGuest.value) {
		typesList = props.vm.currentPage?.formTypeListForIcGuest
	} else {
		typesList = props.vm.currentPage?.formTypeListForIc
	}
	return typesList || [];
})

const formTypeListForOc = computed(() => {
	let typesList = [];
	if (isGuest.value) {
		typesList = props.vm.currentPage?.formTypeListForOcGuest
	} else {
		typesList = props.vm.currentPage?.formTypeListForOc
	}
	return typesList || [];
})

const formTypeListForBc = computed(() => {
	let typesList = [];
	if (isGuest.value) {
		typesList = props.vm.currentPage?.formTypeListForBcGuest
	} else {
		typesList = props.vm.currentPage?.formTypeListForBc
	}
	return typesList || [];
})

const headAlertText = computed(() => {
	return isGuest.value ? props.vm.currentPage.selectionWarningGuest : props.vm.currentPage.selectionWarning;
})

// content-editor configured order falls back to the default, and any type missing from it is appended
// at the end so an invalid/incomplete config never hides a form type
const orderedEnrollmentFormTypes = computed(() => {
	const configuredOrder = props.vm.baseViewModel.enrollmentFormTypesOrder;
	const validOrder = Array.isArray(configuredOrder)
		? configuredOrder.filter((type) => DEFAULT_ENROLLMENT_FORM_TYPES_ORDER.includes(type))
		: [];
	const missingTypes = DEFAULT_ENROLLMENT_FORM_TYPES_ORDER.filter((type) => !validOrder.includes(type));

	return [...validOrder, ...missingTypes];
})

// methods
function goToEnrollmetnForm() {
	if ( fullUrl.value ) {
		localStorage.setItem('SelectedEnrollmentType', JSON.stringify({ url: enrollmentUrl.value, type: enrollmentFormType.value}));
		globalThis.location.assign(fullUrl.value);
	} else {
		isValid.value = false
	}
}

function closeHandler() {
	showPopup.value = false;
}

function updateEnrollmentUrl(event, subList) {
	enrollmentUrl.value = event;
	enrollmentFormType.value = subList[0]?.formType
}

// watch
watch(enrollmentUrl, (newV) => {
	isValid.value = !!newV
});

</script>

<style lang="scss" scoped>
	@import 'multisite/styles/settings/settings';
	@import 'multisite/styles/tools/tools';

	.popup {
		&__headline {
			padding-right: 50px;
		}

		&__button-group {
			margin-bottom: 25px;
		}

		&__guestlink {
			cursor: pointer;
			text-decoration: underline;
		}
	}

	.head{
		margin-top: ds-space(12);
		margin-bottom: ds-space(12);
		align-items: center;

		@include t-respond-to-max(medium) {
			margin-top: ds-space(10);
			margin-bottom: ds-space(10);
		}

		h1 {
			margin-bottom: 0;
		}
	}

	.bg-decorative-3-subtle {
		background: ds-color("bg", "decorative-3-subtle");
	}

	.main {
		padding-top: ds-space(11);
		padding-bottom: ds-space(11);

		@include t-respond-to-max(medium) {
			padding-top: ds-space(10);
			padding-bottom: ds-space(10);
		}
	}

	.alert {
		@include t-respond-to-min(medium) {
			max-width: 514px;
		}
	}

	.inner-list {
		padding-top: ds-space(4);
		margin-left: ds-space(7);
		margin-top: ds-space(10);
		position: relative;

		@include t-respond-to-min(medium) {
			margin-left: ds-space(13);
		}

		&:before {
			content: "";
			position: absolute;
			top: 0;
			bottom: 0;
			left: -20px;
			border-left: 2px solid ds-color("border", "interactive");
		}
	}

	.shake {
	  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
	  transform: translate3d(0, 0, 0);
	  backface-visibility: hidden;
	  perspective: 1000px;
	}

	@keyframes shake {
	  10%,
	  90% {
		transform: translate3d(-1px, 0, 0);
	  }

	  20%,
	  80% {
		transform: translate3d(2px, 0, 0);
	  }

	  30%,
	  50%,
	  70% {
		transform: translate3d(-4px, 0, 0);
	  }

	  40%,
	  60% {
		transform: translate3d(4px, 0, 0);
	  }
	}

	.delay {
		transition-delay: 0.5s;
	}

	.expand-enter-from,
	.expand-leave-to,
	.expand-enter-to,
	.expand-leave-from {
		transition-property: max-height;
		transition-timing-function: cubic-bezier(1, 0.5, 0.8, 1);
		transition-duration: 0.5s;
		overflow: hidden;
		will-change: transform;
	}

	.expand-enter-from,
	.expand-leave-to{
		max-height: 0;
	}

	.expand-enter-to,
	.expand-leave-from {
		max-height: 500px;
		overflow: hidden;
	}
</style>
